import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.border': {
    borderBottom: '1px solid var(--abyss-colors-gray3)',
    borderTop: '1px solid var(--abyss-colors-gray3)',
  },
  '.box': {
    backgroundColor: 'var(--abyss-colors-gray1)',
    marginBottom: 'var(--abyss-space-lg)',
    marginTop: 'var(--abyss-space-md)',
    paddingBottom: 'var(--abyss-space-lg)',
    paddingTop: 'var(--abyss-space-lg)',
    width: 'auto',
    wordWrap: 'break-word',
  },
  '.row': {
    marginLeft: 'calc(var(--abyss-space-md) * -1)',
    marginRight: 'calc(var(--abyss-space-md) * -1)',
  },
});
